export default __webpack_public_path__ + "static/media/icon.59a46ae5.webp";